import { useParams } from "react-router-dom";

import type {
  ParameterizedRoute,
  RouteParams,
} from "../../bootstrap/router.ts";
import { router } from "../../bootstrap/router.ts";

export function useAppParams<R extends ParameterizedRoute>(
  route: R,
): RouteParams[R] {
  const rawParams = useParams();

  return router.parseParams(route, rawParams);
}
